import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Dropdown } from "react-bootstrap";
import { BsFillPersonFill } from "react-icons/bs";
import "./Header.css";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ConfirmationModal from "../Confirmation Modal/ConfirmationModal";
import Common_Fixed_Popup from "../Common Modules/Common_Fixed_Popup";
import { get_aqato_listing_data_api, post_add_user_logs_status_api } from "../../api";
import Loader from "../Widgets/Loader/Loader";
import { useStaffChat } from "../Chat/StaffChatProvider";

const Nav = ({ onLogout }) => {
  // Unread chat messages, shown as a badge on the chat icon
  const { unreadCount } = useStaffChat();
  const [adminName, setAdminName] = useState(
    localStorage.getItem("AQATO_SuperAdminName")
  );

  
  const accountType = localStorage.getItem("AQATO_SuperAdminAccountType") || "";
  const [showDropdown, setShowDropdown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [lunchBreakPopup, setLunchBreakPopup] = useState(false);
  const navigate = useNavigate();
  const toggleRef = useRef(null);
  const menuRef = useRef(null);
  const [logoutClicked, setLogoutClicked] = useState(false);
  const [showConfirmationModalForLogout, setShowConfirmationModalForLogout] =
    useState(false);

  useEffect(() => {
    setAdminName(localStorage.getItem("AQATO_SuperAdminName"));
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        toggleRef.current &&
        !toggleRef.current.contains(event.target)
      ) {
        setShowDropdown(false); // Close the dropdown
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const [staff, setStaff] = useState([
    // { name: "John Doe", email: "john.doe@example.com", status: "online" },
    // { name: "Jane Smith", email: "jane.smith@example.com", status: "lunch" },
    // { name: "Alice Johnson", email: "alice.johnson@example.com", status: "offline" },
    // Add more staff members as needed
  ]);

  const pre_get_aqato_listing_data_api = async () => {
    try {

      const response = await get_aqato_listing_data_api();

      console.log("response?.data?.response?.response", response?.data?.response?.response);

      if (
        response &&
        response?.data &&
        response?.data?.response &&
        response?.data?.response?.response === true
      ) {
        console.log(response?.data?.response?.data?.staffs);
        setStaff(response?.data?.response?.data?.staffs);

      } else {

        console.error(
          "Error",
          response?.data?.error_msg || "Unknown error"
        );

      }
    } catch (error) {

      console.error("Error", error);
    }
  }


  useEffect(() => {
    pre_get_aqato_listing_data_api();
  }, []);


  const getStatusIcon = (status) => {
    switch (status) {
      case "online":
        return <i className="bi bi-circle-fill text-success custom_icons_for_active"></i>;
      case "lunch":
        return <i className="bi bi-circle-fill text-warning custom_icons_for_active"></i>;
      case "offline":
        return <i className="bi bi-circle-fill text-secondary custom_icons_for_active"></i>;
      default:
        return null;
    }
  };


  // Handle logout click
  const handleLogout = () => {
    setShowConfirmationModalForLogout(true);
    setLogoutClicked(true);
  };

  const handleLunchBreak = () => {
    // navigate("/admin/lunch_break");
    setLunchBreakPopup(true);
  }

  const startLunchBreak = async() => {
    // Set Local to lunch
    localStorage.setItem("user_status", "lunch");
    localStorage.removeItem("lunch_end_time");
    // end
    await pre_post_add_user_logs_status_api('lunch');

    const userId = localStorage.getItem('AQATO_SuperAdminID');
    const channel = new BroadcastChannel('user-status-channel');
    channel.postMessage({ type: 'lunch', userId });

  }


  const pre_post_add_user_logs_status_api = async (user_status) => {
    const formData = new FormData();

    formData.append("user_status", user_status);

    try {

      const response = await post_add_user_logs_status_api(
        formData
      );
      
      if (
        response &&
        response?.data &&
        response?.data?.response &&
        response?.data?.response?.response === true &&
        response?.data?.response?.data
      ) {
        
      } else {

        console.error(
          "Error in deleting",
          response?.data?.error_msg || "Unknown error"
        );

      }
    } catch (error) {

      console.error("Error in deleting", error);
    }
  }


  // Confirm logout action
  const handleConfirmationLogoutYes = async () => {
    setIsLoading(true);
    console.log("Nav js");
    await pre_post_add_user_logs_status_api("offline");
    // localStorage.clear();
    onLogout();
    navigate("/");
    toast.success("Logged out successfully!");
    setShowConfirmationModalForLogout(false);
    setLogoutClicked(false);
  };

  // Cancel logout action
  const handleConfirmationLogoutNo = () => {
    setShowConfirmationModalForLogout(false);
    setLogoutClicked(false);
  };

  // Toggle dropdown on user icon click
  const handleDropdownToggle = () => {
    setShowDropdown((prev) => !prev);
  };


  const handleNavigateDashboard = () => {
    const storedStatus = localStorage.getItem('user_status');
    // console.log(curr_URL + "dsa" + storedStatus);

    // window.location.href
    if (storedStatus === "lunch") {
      // window.location.href = "/admin/lunch_break_started";
      navigate('/admin/lunch_break_started');
    }
    else {
      navigate("/admin/dashboard");
    }

  }

  const handleNavigateTM = () => {
    const storedStatus = localStorage.getItem('user_status');
    // console.log(curr_URL + "dsa" + storedStatus);

    // window.location.href
    if (storedStatus === "lunch") {
      // window.location.href = "/admin/lunch_break_started";
      navigate('/admin/lunch_break_started');
    }
    else {
      navigate("/admin/all_staff_status");
    }

  }

  const handleNavigateChat = () => {
    const storedStatus = localStorage.getItem('user_status');

    if (storedStatus === "lunch") {
      navigate('/admin/lunch_break_started');
    }
    else {
      navigate("/admin/chat");
    }

  }


  useEffect(() => {
    const intervalId = setInterval(() => {
      // Function to be executed every 10 seconds
      pre_get_aqato_listing_data_api();
    }, 10000);

    // Clear the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, []);


  return (
    <>
    {isLoading && <Loader />}
      <Row className="mb-0">
        <Col
          className="d-flex justify-content-end align-items-center"
          style={{ marginRight: "25px", color: "#055837" }}
        >

          {/* <div className="currentStatus me-3 text-dark">
            <span className="me-1">
              <i class="bi bi-globe-asia-australia"></i>
            </span>
            <span>Online</span>
          </div> */}

        {/* Staff chat: icon only, with a badge when there are unread messages */}
        {accountType !== "aqato_read_only" && (
          <button
            type="button"
            className="btn border-0 d-flex align-items-center"
            style={{
              position: "relative",
              color: "#055837",
              outline: "none",
              boxShadow: "none",
            }}
            onClick={handleNavigateChat}
            title="Chat"
            aria-label="Chat"
          >
            <i
              className="bi bi-chat-dots-fill"
              style={{ color: "#055837", fontSize: "18px" }}
            />
            {unreadCount > 0 && (
              <span
                style={{
                  position: "absolute",
                  top: "0px",
                  right: "0px",
                  minWidth: "18px",
                  height: "18px",
                  padding: "0 5px",
                  borderRadius: "9px",
                  backgroundColor: "#dc3545",
                  color: "#fff",
                  fontSize: "11px",
                  fontWeight: "600",
                  lineHeight: "18px",
                  textAlign: "center",
                }}
              >
                {unreadCount > 99 ? "99+" : unreadCount}
              </span>
            )}
          </button>
        )}
{/* 
        {accountType !== "head_office" && (
          <Dropdown>
          <Dropdown.Toggle
            variant=""
            id="user-dropdown"
            className="border-0 text-dark d-flex align-items-center"
            style={{ color: "#055837", outline: "none", boxShadow: "none" }}
          >
            <i class="bi bi-people-fill" style={{ color: "#055837" }} />
            <span
              style={{
                color: "#055837",
                textDecoration: "none",
                transition: "text-decoration 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.textDecoration = "underline";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.textDecoration = "none";
              }}
            >
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu
            ref={menuRef}
            style={{
              border: "2px solid #ffcc01",
              borderRadius: "5px",
              backgroundColor: "white",
              padding: "0",
              alignItems: "center",
              position: "absolute",
              zIndex: 1000,

            }}
            className="shadow"
          >





            {staff.length > 0 && (
              staff.map((member, index) => (



                <Dropdown.Item
                  className={(index > 0) ? "custom-dropdown-item d-flex align-item-center status_showing_dropdown border-top" : "custom-dropdown-item d-flex align-item-center status_showing_dropdown"}
                >
                  <div className="active_img_wrapper">
                    {getStatusIcon(member.status)}
                    <img src="https://api.aqato.com.au/public/Logos/lunch_imgs/user_icon.png"
                      style={{
                        width: "30px",
                        marginRight: "5px"
                      }}
                    />
                  </div>
                  <div className="text_wrapper_active">
                    {member.name}
                  </div>
                </Dropdown.Item>






              ))
            )}



          </Dropdown.Menu>
        </Dropdown>

        )} */}
          

          <Dropdown>
            <Dropdown.Toggle
              variant=""
              id="user-dropdown"
              className="border-0 text-dark d-flex align-items-center"
              style={{ color: "#055837", outline: "none", boxShadow: "none" }}
            >
              <BsFillPersonFill className="me-1" style={{ color: "#055837" }} />
              <span
                style={{
                  color: "#055837",
                  textDecoration: "none",
                  transition: "text-decoration 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.textDecoration = "underline";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.textDecoration = "none";
                }}
              >
                Welcome <b>{adminName}</b>
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu
              ref={menuRef}
              style={{
                border: "2px solid #ffcc01",
                borderRadius: "5px",
                // backgroundColor: "transparent",
                backgroundColor: "white",
                padding: "0",
                alignItems: "center",
                position: "absolute",
                zIndex: 1000,

              }}
              className="shadow"
            >
              {/* <Dropdown.Item
              className="custom-dropdown-item"
              onClick={handleNavigateDashboard}
            >
              <i class="bi bi-house-door-fill"></i> Dashboard
            </Dropdown.Item> */}
            {accountType !== "head_office" && (
              <Dropdown.Item
                className="custom-dropdown-item border-top"
                onClick={handleLunchBreak}
              >
                <i class="bi bi-pause-circle-fill"></i> Break
              </Dropdown.Item>
            )}


              {/* <Dropdown.Item
                className="custom-dropdown-item border-top"
                onClick={handleNavigateTM}
              >
                <i class="bi bi-people-fill"></i> TM
              </Dropdown.Item> */}

              <Dropdown.Item
                onClick={handleLogout}
                className="custom-dropdown-item border-top"
              >
                <i className="bi bi-power"></i> Sign Out
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Col>
      </Row>

      {logoutClicked && (
        <ConfirmationModal
          show={showConfirmationModalForLogout}
          onHide={handleConfirmationLogoutNo}
          onConfirm={handleConfirmationLogoutYes}
          title="Confirm Logout"
          message="Are you sure you want to Log Out?"
        />
      )}

      <Common_Fixed_Popup
        show={lunchBreakPopup}
        onStopBreak={() => {
          setLunchBreakPopup(false);
        }}
        popup_body={
          <>
            <img src="https://attc.aqato.com.au/public/Logos/lunch_imgs/lunch_confirmation.png"
              className="mx-auto d-block mb-2"
            />
            <h5 className="text-center my-1">Are you sure you want to take Break?</h5>
            <div className="d-flex justify-content-center">

              <button type="button" title="Start Break" className="btn_green_yellow ml-1 mr-1 btn btn-primary"
                onClick={() => {
                  setLunchBreakPopup(false);
                  setIsLoading(true);
                  startLunchBreak();
                }}

              >
                <i class="bi bi-play-fill" /> Start Break
              </button>

              <button type="button" title="Go Back to Homepage" className="btn_yellow_green btn btn-primary"
                onClick={() => {
                  setLunchBreakPopup(false);
                }}
                style={{ outline: 'none', boxShadow: 'none', border: 'none' }}>
                <i class="bi bi-x-circle-fill" /> Close
              </button>

            </div>

          </>
        }
      />
    </>
  );
};

export default Nav;
